export const CalculatorElementsEnum = {
  BUTTON: 'button',
  BUTTON_GROUP: 'buttonGroup',
  CHAMBER_OF_COMMERCE: 'chamberOfCommerce',
  CHECKBOX: 'checkbox',
  COLUMN: 'column',
  COLUMNS: 'columns',
  CONTAINER: 'container',
  COUPON: 'coupon',
  DATE: 'date',
  DATES: 'dates',
  DIVIDER: 'divider',
  DROPDOWN: 'dropdown',
  EMAIL: 'email',
  FILE: 'file',
  FORMULA: 'formula',
  LAYERED_IMAGES: 'layeredImages',
  IMAGE: 'image',
  ORDER_LIST: 'orderList',
  PHONE: 'phone',
  PLACE: 'place',
  PLACES: 'places',
  PROGRESS_BAR: 'progressBar',
  MULTIPLE_CHOICE: 'multipleChoice',
  MULTIPLE_SELECTION: 'multipleSelection',
  NUMBER: 'number',
  NUMBER_INCREMENTER: 'numberIncrementer',
  RADIO_GROUP: 'radioGroup',
  RANGE_SLIDER: 'rangeSlider',
  SWITCH: 'switch',
  STATE_BUTTON: 'stateButton',
  SIGNATURE: 'signature',
  TABLE: 'table',
  TEXT: 'text',
  TEXT_FIELD: 'textField',
  TIME: 'time',
  TIMESLOT: 'timeslot',
  HEADING: 'heading',
  VIEW_BREAK: 'viewBreak',
  CHART: 'chart',
  VIEW_CONTAINER: 'viewContainer',
  VIEW: 'view',
  VIEW_NAVIGATION: 'viewNavigation',
};

export const CalculatorElementsCollection = {
  [CalculatorElementsEnum.BUTTON]: 'elements',
  [CalculatorElementsEnum.BUTTON_GROUP]: 'questions',
  [CalculatorElementsEnum.CHAMBER_OF_COMMERCE]: 'questions',
  [CalculatorElementsEnum.CHECKBOX]: 'questions',
  [CalculatorElementsEnum.COLUMN]: 'elements',
  [CalculatorElementsEnum.COLUMNS]: 'elements',
  [CalculatorElementsEnum.CONTAINER]: 'elements',
  [CalculatorElementsEnum.COUPON]: 'questions',
  [CalculatorElementsEnum.DATE]: 'questions',
  [CalculatorElementsEnum.DATES]: 'questions',
  [CalculatorElementsEnum.DIVIDER]: 'elements',
  [CalculatorElementsEnum.DROPDOWN]: 'questions',
  [CalculatorElementsEnum.EMAIL]: 'questions',
  [CalculatorElementsEnum.FILE]: 'questions',
  [CalculatorElementsEnum.FORMULA]: 'formulas',
  [CalculatorElementsEnum.LAYERED_IMAGES]: 'formulas',
  [CalculatorElementsEnum.IMAGE]: 'elements',
  [CalculatorElementsEnum.ORDER_LIST]: 'questions',
  [CalculatorElementsEnum.PHONE]: 'questions',
  [CalculatorElementsEnum.PLACE]: 'questions',
  [CalculatorElementsEnum.PLACES]: 'questions',
  [CalculatorElementsEnum.MULTIPLE_CHOICE]: 'questions',
  [CalculatorElementsEnum.MULTIPLE_SELECTION]: 'questions',
  [CalculatorElementsEnum.NUMBER]: 'questions',
  [CalculatorElementsEnum.NUMBER_INCREMENTER]: 'questions',
  [CalculatorElementsEnum.RADIO_GROUP]: 'questions',
  [CalculatorElementsEnum.RANGE_SLIDER]: 'questions',
  [CalculatorElementsEnum.SWITCH]: 'questions',
  [CalculatorElementsEnum.STATE_BUTTON]: 'questions',
  [CalculatorElementsEnum.SIGNATURE]: 'questions',
  [CalculatorElementsEnum.TABLE]: 'formulas',
  [CalculatorElementsEnum.TEXT]: 'elements',
  [CalculatorElementsEnum.TEXT_FIELD]: 'questions',
  [CalculatorElementsEnum.TIME]: 'questions',
  [CalculatorElementsEnum.TIMESLOT]: 'questions',
  [CalculatorElementsEnum.HEADING]: 'elements',
  [CalculatorElementsEnum.VIEW_BREAK]: 'elements',
  [CalculatorElementsEnum.CHART]: 'formulas',
  [CalculatorElementsEnum.VIEW_CONTAINER]: 'elements',
  [CalculatorElementsEnum.VIEW]: 'elements',
  [CalculatorElementsEnum.VIEW_NAVIGATION]: 'elements',
  [CalculatorElementsEnum.PROGRESS_BAR]: 'formulas',
};
